<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue';
import {
  CdrText,
} from '@rei/cedar';
// import { camelCase } from '../../../../common/utils';
// import { sendClickAnalytics } from '../../../../utils';
// import tags from '../../../../utils/globalTags';
import { useIcons } from '../../../../common/composables/useIcons';
import { apiCall } from '../../../../api/services/apiCalls';
import { useDataParsing } from '../../../../common/composables/useArrayParsing';
import { QuickToolsModel } from '../../../../api/types/QuickToolsModel';
import { TopToolsIconsMap } from './IconsMap';

const { activeSection } = defineProps<{
  activeSection: string,
}>();
const quickToolsArray: Ref<QuickToolsModel[]> = ref([]);

const formatIconName = (title: string) => title.toLowerCase().split(' ').join('_');

const handleRedirectOnClick = (tool: QuickToolsModel) => {
  // const adobeMainTag = from
  //   ? `${(adobeTag?.replace(/([^\w]+|\s+)/g, '_'))}_Tools`
  //   : 'Homepage_Tools';
  // const clickData = {
  //   pageName: null,
  //   linkName: `${tags.HELP_CENTER}_${adobeMainTag}_${camelCase(tool.title)}`,
  // };
  // sendClickAnalytics(clickData);
  window.open(tool.url, '_self');
};

onMounted(async () => {
  quickToolsArray.value = await apiCall('default', 'quick-tools', activeSection).then((res) => useDataParsing('threeWaysArray', res).flat());
});
</script>

<template>
  <div
    v-if="quickToolsArray.length"
    class="help-centers-u__top-tools"
  >
    <CdrText
      tag="h2"
      class="help-centers-u__top-tools-header"
    >
      Quick Tools
    </CdrText>
    <div
      role="button"
      v-for="(tool) in quickToolsArray"
      @click="handleRedirectOnClick(tool)"
      :key="tool.buttonTitle"
      class="help-centers-u__top-tools-tool"
    >
      <component
        :is="useIcons(TopToolsIconsMap[formatIconName(tool.buttonTitle)] ?? 'IconShipping')"
        class="help-centers-u__top-tools-icon"
      />
      <CdrText
        tag="h3"
        class="help-centers-u__top-tools-legend"
      >
        {{ tool.title }}
      </CdrText>
      <component
        :is="useIcons('IconArrowRight')"
        class="help-centers-u__top-tools-icon"
      />
    </div>
  </div>
</template>

<style lang="scss">
  @import 'src/main/style/helpCenterColumnsUpdate.scss';
</style>
